var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgResource(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m449.488 88.351v-58.351h32.512v-30h-62.512v58.972c-45.857-38.187-103.075-58.972-163.488-58.972-68.38 0-132.667 26.629-181.02 74.98-48.351 48.353-74.98 112.64-74.98 181.02s26.629 132.667 74.98 181.02c48.353 48.351 112.64 74.98 181.02 74.98s132.667-26.629 181.02-74.98c48.351-48.353 74.98-112.64 74.98-181.02 0-62.254-22.071-121.116-62.512-167.649zm-33.682 327.455c-42.686 42.686-99.439 66.194-159.806 66.194s-117.12-23.508-159.806-66.194-66.194-99.439-66.194-159.806 23.508-117.12 66.194-159.806 99.439-66.194 159.806-66.194 117.12 23.508 159.806 66.194c.279.279.557.559.835.84-3.86-1.083-7.928-1.663-12.129-1.663-24.8 0-44.977 20.187-44.977 45s20.177 45 44.977 45 44.977-20.187 44.977-45v-1.325c21.191 34.916 32.511 75.065 32.511 116.954 0 60.367-23.508 117.12-66.194 159.806zm3.682-275.435c0 8.271-6.719 15-14.977 15s-14.977-6.729-14.977-15 6.719-15 14.977-15 14.977 6.729 14.977 15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m96.313 256h-30c0 104.593 85.093 189.687 189.687 189.687v-30c-88.052 0-159.687-71.636-159.687-159.687z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m256 149.687c-58.582 0-106.241 47.692-106.241 106.313s47.659 106.313 106.241 106.313 106.241-47.692 106.241-106.313-47.659-106.313-106.241-106.313zm0 182.626c-42.039 0-76.241-34.234-76.241-76.313s34.202-76.313 76.241-76.313 76.241 34.234 76.241 76.313-34.202 76.313-76.241 76.313z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m256 211c-24.8 0-44.977 20.187-44.977 45s20.177 45 44.977 45 44.977-20.187 44.977-45-20.177-45-44.977-45zm0 60c-8.258 0-14.977-6.729-14.977-15s6.719-15 14.977-15 14.977 6.729 14.977 15-6.719 15-14.977 15z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResource);
export default __webpack_public_path__ + "static/media/resource.c71b41d584e0f35ff2304ed6e8367806.svg";
export { ForwardRef as ReactComponent };